import { useCallback, useMemo } from 'react';
import {
  selectMeteorologyAgroWBSequentialDVSoil,
  setSoil,
} from 'redux/reducers/meteorologyAgroWBSequentialDVReducer';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import useOptions from './useOptions';

export default function useSoil() {
  const { options } = useOptions();
  const soilTypes = useMemo(() => (options ? options.soilTypes : []), [options]);
  const selectedSoil = useSelector(selectMeteorologyAgroWBSequentialDVSoil);

  const closeAccordion = useMemo(() => buildAccordionClickFunction('soil-accordion'), []);

  const onSoilClick = useCallback((soil: number) => () => {
    store.dispatch(setSoil(soil));
    closeAccordion();
  }, [closeAccordion]);

  return {
    selectedSoil,
    soilTypes,
    onSoilClick,
  };
}
